app.controller('popupPrescriptionController', ['$scope', '$state', '$mdDialog', '$timeout', '$translate', 'objectHelper',
    'baseModel', 'applicationModel', 'visitModel', 'userModel', 'doctorModel', 'patientModel', 'dictionaryModel', 'prescriptionModel',
    'prescriptionData', 'visitCardData', 'patientData', 'prescriptionType', 'previewOnly', 'p2DrugModel', 'prescribedDrugModel', 'visitCardModel',
    function ($scope, $state, $mdDialog, $timeout, $translate, objectHelper, baseModel, applicationModel, visitModel,
              userModel, doctorModel, patientModel, dictionaryModel, prescriptionModel, prescriptionData, visitCardData,
              patientData, prescriptionType, previewOnly, p2DrugModel, prescribedDrugModel, visitCardModel) {


        // fixme - hack for md dialog scrolling
        $timeout(function () {
            $('.md-dialog-container').css('align-items', 'flex-start');
            $('.md-dialog-container').css('overflow', 'auto');
        });

        function beforeSave() {
            $scope.prescription.visitCard = new VisitCardVO($scope.visit.visitCard.id);
        }

        function deleteDrug(drug, callback) {
        }

        function setData() {
            if(!prescriptionData) {
                $scope.prescription = new PrescriptionVO();
                $scope.prescription.prescribedDrugs = [];
                $scope.prescription.dateFrom = null;
                $scope.prescription.issueDate = new Date();
                $scope.prescription.type = prescriptionType;
                $scope.prescription.additionalRight = null;
            } else {
                $scope.prescription = angular.copy(prescriptionData);
            }

            $scope.visit = visitCardData;
            $scope.patient = patientData;
            $scope.doctor = null;
            $scope.drugPaymentTypes = Object.keys(Enum.DRUG_PAYMENT_TYPE);
            $scope.Enum = Enum;
            switch($scope.prescriptionType) {
                case Enum.PRESCRIPTION_TYPE.RP:
                    $scope.entityLookupController = 'esEntityLookupP2DrugRPController';
                    break;
                case Enum.PRESCRIPTION_TYPE.RPW:
                    $scope.entityLookupController = 'esEntityLookupP2DrugRPWController';
                    break;
            }

            $scope.p2DrugNewField = null;
            $scope.drugLimitOptions = {
                RP: 5,
                RPW: 1,
                RCP: 1
            };

            $scope.prescribedDrugsLimit = $scope.drugLimitOptions[$scope.prescription.type];
            $scope.previewOnly = previewOnly;

            if($scope.prescription.type === Enum.PRESCRIPTION_TYPE.RCP && $scope.prescription.alreadyPrinted) {
                $scope.previewOnly = true;
            }

            $scope.presentDate = new Date();
            $scope.minDate = moment({
                year: $scope.presentDate.getFullYear(),
                month: $scope.presentDate.getMonth(),
                day: $scope.presentDate.getDate()
            }).add('days', 1).toDate();

            $scope.patientAge = ($scope.patient.birthDate) ? $scope.presentDate.getFullYear() - $scope.patient.birthDate.getFullYear() : null;

            $scope.tempPrescribedDrug = null;

            $scope.forms = {
                prescription: null
            };

            if(!$scope.prescription.id && $scope.prescription.type === Enum.PRESCRIPTION_TYPE.RCP) {
                var recipeDrug = new PrescribedDrugVO();
                recipeDrug.patient = new PatientVO($scope.patient.id);
                recipeDrug.count = 1;
                $scope.prescription.prescribedDrugs.push(recipeDrug);
            }

            $scope.drugsToBeDeleted = [];
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch('p2DrugNewField', function(newVal, oldVal) {
                if($scope.prescription.prescribedDrugs.length >= 5) {
                    return false;
                }

                if(!_.isUndefined(newVal) && newVal != null) {
                    $scope.tempPrescribedDrug = new PrescribedDrugVO();
                    $scope.tempPrescribedDrug.patient = new PatientVO($scope.patient.id);
                    $scope.tempPrescribedDrug.drug = newVal;
                    $scope.tempPrescribedDrug.p2DrugId = newVal.id;
                    $scope.tempPrescribedDrug.drugPaymentType = $scope.drugPaymentTypes[$scope.drugPaymentTypes.length-1];
                    // end-point require "packages" as array of string. That's why created "packagesObj" to get id after select.
                    $scope.tempPrescribedDrug.drug.packagesObj = newVal.packages;
                    $scope.tempPrescribedDrug.drug.packages = newVal.packages.map(function (p) {
                        return p.drugPackage;
                    });

                    var disabler = $scope.$watch('tempPrescribedDrug.drug.packing', function (newVal) {
                        if(newVal) {
                            disabler();
                            $scope.prescription.prescribedDrugs.push($scope.tempPrescribedDrug);
                            $scope.tempPrescribedDrug = null;
                            $scope.p2DrugNewField = undefined;
                        }
                    });
                }
            });

            $scope.$on(Event.DICTIONARY.GET_DICTIONARY_ELEMENT_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
                if(code === Constant.DICTIONARY_CODE.ADDITIONAL_RIGHT) {
                    $scope.additionalRightList = [null].concat(dataPage.data);

                }
            });

            $scope.$on(Event.DOCTOR.GET_BY_ID.SUCCESS, function (event, data) {
                $scope.doctor = data;
            });

        }

        function setActions() {

            $scope.signPrescription = function() {
                beforeSave();

                $scope.forms.prescription.$setSubmitted();
                if($scope.forms.prescription.$valid) {

                        var configPopup = {
                            templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-sign-prescription.html',
                            controller: 'popupSignPrescriptionController',
                            controllerAs: 'signPrescriptionCtrl',
                            skipHide: true,
                            locals: {
                                $scope: $scope,
                                $mdDialog: $mdDialog,
                                title: 'Podpisz receptę certyfikatem ZUS',
                                message: 'Podaj hasło do certyfikatu',
                                altButtons: false
                            }
                        };

                        $mdDialog.show(configPopup).then(function(password) {
                            if(password) {
                                $scope.prescription.certificatePassword = password;
                                $scope.save(true, true);
                            }
                        });
                }
            }

            $scope.save = function(print, ePrescription) {
                beforeSave();

                $scope.forms.prescription.$setSubmitted();
                if($scope.forms.prescription.$valid) {
                    if($scope.prescription.id) {
                        var deletedDrugsCounter = $scope.drugsToBeDeleted.length;
                        var savedDrugsCounter = $scope.prescription.prescribedDrugs.filter(function(drug) { return !drug.id }).length;

                        if(deletedDrugsCounter) {
                            $scope.drugsToBeDeleted.forEach(function(presDrug) {
                                prescribedDrugModel.delete(presDrug).then(function (drug) {
                                    deletedDrugsCounter--;
                                    if(deletedDrugsCounter === 0) {
                                        updatePrescription();
                                    }
                                });
                            })
                        }
                        if(savedDrugsCounter) {
                            $scope.prescription.prescribedDrugs.forEach(function(presDrug) {
                                if(presDrug.id) {
                                    return false;
                                }
                                var newDrug = angular.copy(presDrug);
                                delete newDrug.id;
                                delete newDrug.drug.id;
                                prescribedDrugModel.save(newDrug).then(function (drug) {
                                    _.remove($scope.prescription.prescribedDrugs, function(element) {
                                        return element === presDrug;
                                    });

                                    $scope.prescription.prescribedDrugs.push(drug);
                                    savedDrugsCounter--;
                                    if(savedDrugsCounter === 0) {
                                        updatePrescription();
                                    }
                                });
                            })
                        } else {
                            updatePrescription();
                        }
                    } else {
                        if($scope.prescription.type != Enum.PRESCRIPTION_TYPE.RCP) {
                            $scope.prescription.prescribedDrugs.forEach(function(presDrug) {
                                delete presDrug.drug.id;
                            });
                        }
                        if(ePrescription){
                            prescriptionModel.eSave($scope.prescription)
                                .then( function(prescription) {
                                    visitCardModel.getP1ById(prescription.id).then(
                                        function(prescriptionHTML) {
                                            $mdDialog.show({
                                                template: prescriptionHTML,
                                                clickOutsideToClose: true
                                            });
                                        }
                                    );
                                }).catch( function() {
                                    $mdDialog.show({
                                        templateUrl: 'edm/application/view/app/popup/popup-error.html',
                                        controller: 'popupErrorController',
                                        skipHide: true,
                                        resolve: {
                                            error: function () {
                                                return {
                                                    title: 'Wystąpił błąd przy zapisie e-recepty',
                                                    message: 'W celu zapisania e-recepty należy podać prawidłowe hasło oraz uzupełnić wszystkie dane: osobowe, placówki i gabinetu. Trzeba także wgrać wymagane certyfikaty'
                                                };
                                            }
                                        }
                                    });
                            });
                        } else {
                            prescriptionModel.save($scope.prescription).then(function(prescription) {
                                checkForDownload(prescription);
                            });
                        }
                    }

                    function updatePrescription () {
                        prescriptionModel.update($scope.prescription).then(function(prescription) {
                            checkForDownload(prescription);
                        })
                    }

                    function checkForDownload(pres) {
                        if(print) {
                            $scope.previewOnly = true;
                            prescriptionModel.downloadPDF(pres.id).then(function(link) {
                                window.open(link, '_blank');
                                window.focus();
                                $mdDialog.hide(pres);
                            });
                        }
                    }
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.saveAndPrint = function() {
                if($scope.prescription.id) {
                    prescriptionModel.downloadPDF($scope.prescription.id);
                } else {
                    beforeSave();

                    $scope.forms.prescription.$setSubmitted();
                    if($scope.forms.prescription.$valid) {
                        prescriptionModel.save($scope.prescription);

                        var successDisabler = $scope.$on(Event.PRESCRIPTION.SAVE.SUCCESS, function (event, prescription) {
                            successDisabler();
                            $scope.prescription = prescription;
                            $scope.previewOnly = true;
                            prescriptionModel.downloadPDF($scope.prescription.id);
                            $mdDialog.hide($scope.prescription);
                        });
                    }
                }
            };


            $scope.removeDrugEntry = function(array, drug) {
                var remove = false;
                if(drug.alreadyPrinted) {

                    var label = drug.drug.name;
                    var configPopup = {
                        templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                        controller: 'popupDeleteWithReasonController',
                        controllerAs: 'deleteConfirmCtrl',
                        skipHide: true,
                        locals: {
                            labels: label,
                            item: drug,
                            userModel: userModel,
                            $mdDialog: $mdDialog,
                            message: 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION'
                        }
                    };

                    $mdDialog.show(configPopup).then(function(data) {
                        if(data) {
                            prescribedDrugModel.update(data).then(function() {
                                visitModel.getById($stateParams.visitId).then(listeners.onGetVisitById);
                            })
                        }
                    });


                }
                if(drug.id && !drug.alreadyPrinted) { // dodać obsługę usuwania przy zapisie ale nie na Anuluj
                    $scope.drugsToBeDeleted.push(drug);
                    remove = true;
                }
                if(!drug.id) {
                    remove = true;
                }
                if(remove) {
                    _.remove($scope.prescription.prescribedDrugs, function(presDrug) {
                        return presDrug === drug;
                    })
                }
            };

            $scope.selectPackage = function (p) {
                if(p) {
                    $scope.tempPrescribedDrug.pharmindexDrugPackageId = p.id;
                    $scope.tempPrescribedDrug.drug.packing = p.drugPackage;
                    $scope.tempPrescribedDrug.drug.packingCapacity = p.quantity;
                    // it's not need to be send
                    delete $scope.tempPrescribedDrug.drug.packagesObj;
                    $scope.tempPrescribedDrug.drug.paymentLevels = p.paymentLevels;
                } else {
                    $scope.tempPrescribedDrug = null;
                    $scope.p2DrugNewField = undefined;
                }

                setTimeout(function () {
                    var el = document.getElementsByClassName('prescription-drug-list')[0];
                    scrollToElementBottom(el);
                });

            };

            $scope.countAdditionalNotes = function (text) {
                var number = 0;
                if(text) {
                    number = text.length;
                }
                return number;
            };
        }

        function configureInterface() {

        }

        function scrollToElementBottom(el) {
            if (el) {
                el.scrollTo({
                    top: el.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }

        function initialize() {
            var criteria = {};
            dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ADDITIONAL_RIGHT, criteria);
            doctorModel.getById(userModel.getCurrentContextDoctorId());
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
